import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=400235c4&scoped=true"
import script from "./BookingCard.vue?vue&type=script&lang=js"
export * from "./BookingCard.vue?vue&type=script&lang=js"
import style0 from "./BookingCard.vue?vue&type=style&index=0&id=400235c4&prod&lang=css"
import style1 from "./BookingCard.vue?vue&type=style&index=1&id=400235c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400235c4",
  null
  
)

export default component.exports